import { Pipe, PipeTransform } from '@angular/core';
import * as luxon from 'luxon';

@Pipe({
  name: 'relativeDate',
  standalone: true,
})
export class LuxonDatePipe implements PipeTransform {
  transform(value: string | luxon.DateTime | Date): string {
    let useValue: luxon.DateTime;
    if (typeof value === 'string') {
      useValue = luxon.DateTime.fromISO(value);
    } else if (value instanceof Date) {
      useValue = luxon.DateTime.fromJSDate(value);
    } else {
      useValue = value;
    }
    if (useValue.isValid) {
      return useValue.toRelative({ locale: 'cs' })!;
    }
    throw EvalError("couldn't coerce value to DateTime");
  }
}
